var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mobile-navigation",
      class: { open: _vm.isMobileNavigationOpen },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNavigationInitialized,
              expression: "isNavigationInitialized",
            },
          ],
        },
        [
          _c("div", { staticClass: "btn-close" }, [
            _c(
              "svg",
              {
                staticClass: "mobile-nav__chevron",
                attrs: { fill: "currentColor", width: "24", height: "24" },
                on: {
                  click: function ($event) {
                    return _vm.closeNavigation()
                  },
                },
              },
              [_c("use", { attrs: { "xlink:href": "#cancel" } })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [{ name: "menu", rawName: "v-menu" }],
              staticClass: "mainmenu w-100 p-0 m-0 menu-active",
              attrs: { id: "menu-1" },
            },
            [
              _c(
                "div",
                { staticClass: "accordion", attrs: { id: "accordion" } },
                _vm._l(_vm.dataContainer1.categories, function (category) {
                  return _c(
                    "div",
                    {
                      staticClass: "card",
                      class: {
                        "about-cat": category.id === 11,
                        "magazin-cat": category.id === 150,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header",
                          attrs: { id: "cat-heading-" + category.id },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-link collapsed",
                              attrs: {
                                "data-toggle": "collapse",
                                "data-target": "#cat-body-" + category.id,
                                "aria-expanded": "true",
                                "aria-controls": "cat-body-" + category.id,
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(category.details[0].name)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "svg",
                                {
                                  staticClass: "mobile-nav__chevron",
                                  attrs: { fill: "currentColor" },
                                },
                                [
                                  _c("use", {
                                    attrs: { "xlink:href": "#chevron-down" },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "collapse",
                          attrs: {
                            id: "cat-body-" + category.id,
                            "aria-labelledby": "cat-heading-" + category.id,
                            "data-parent": "#accordion",
                          },
                        },
                        [
                          _c("div", { staticClass: "card-body" }, [
                            _c(
                              "ul",
                              [
                                _c("li", { staticClass: "show-all" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getCategoryUrl(category.url),
                                      },
                                    },
                                    [
                                      category.id === 11
                                        ? [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HoferAntikschmuck::Template.showAllAboutUs"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        : category.id === 150
                                        ? [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HoferAntikschmuck::Template.showAllMagazin"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        : [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "HoferAntikschmuck::Template.all"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  category.details[0].name
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(category.children, function (child) {
                                  return _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.getCategoryUrl(child.url),
                                        },
                                      },
                                      [_vm._v(_vm._s(child.details[0].name))]
                                    ),
                                  ])
                                }),
                              ],
                              2
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "accordion", attrs: { id: "accordion-2" } },
                [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      {
                        staticClass: "card-header",
                        attrs: { id: "cat-heading-links" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-link",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": "#cat-body-links",
                              "aria-expanded": "true",
                              "aria-controls": "cat-body-links",
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "HoferAntikschmuck::Template.myHofer"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                staticClass: "mobile-nav__chevron",
                                attrs: { fill: "currentColor" },
                              },
                              [
                                _c("use", {
                                  attrs: { "xlink:href": "#chevron-down" },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "collapse show",
                        attrs: {
                          id: "cat-body-links",
                          "aria-labelledby": "'cat-heading-links",
                          "data-parent": "#accordion-2",
                        },
                      },
                      [
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "ul",
                            [
                              _c("user-login-handler", {
                                attrs: { "is-mobile-nav": true },
                              }),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  { attrs: { href: _vm.$ceres.urls.basket } },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { stroke: "currentColor" } },
                                      [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#shopping-bag",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "HoferAntikschmuck::Template.headerBasketLabel"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  { attrs: { href: _vm.$ceres.urls.wishList } },
                                  [
                                    _c(
                                      "svg",
                                      { attrs: { stroke: "currentColor" } },
                                      [
                                        _c("use", {
                                          attrs: { "xlink:href": "#wishlist" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.wishList"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _vm._t("languageselect"),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }